import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {ItemProvider} from "../../providers/item-provider/item-provider.service";
import {AppDataService} from "../../../../services/AppDataService";
import {Item} from "../../../../../framework/model/core/items/item";
import {OrderService} from "../../../../services/OrderService";
import {BusinessService} from "../../../../services/BusinessService";
import {PropsProvider} from "../../providers/props-provider/props-provider.service";
import {Events} from "../../../../../framework/providers/events";
import {CartModel} from "../../../../../framework/model/core/items/cartModel";
import {CartService} from "../../../../services/CartService";

@Component({
    selector: 'item-deal-props',
    templateUrl: './item-deal-props.page.html',
    styleUrls: ['./item-deal-props.page.scss'],
})
export class ItemDealPropsPage implements OnInit {

    @Input()
    public model: any;

    @Input()
    public checkedProps: object = {};

    @Input()
    public cartItem: object = {};

    @Input()
    public cart_model:CartModel;

    @Input()
    public options: object = {};

    @Input()
    public propsEvent: string;

    @Input()
    public btnTitle: string;

    @Input()
    public isItemDetails:boolean=true;

    @Input()
    public comments:string;


    public catalog:boolean= this.businessService.isCatalog();

    public typesCheck:object = {}

    public cartData;
    public props;


    constructor(public modalController: ModalController, public events:Events, public appDataService:AppDataService,
                public orderService:OrderService, public propsProvider:PropsProvider,
                public businessService:BusinessService, public cartService:CartService) {
        this.cartData = this.orderService.getCartData();
    }

    ngOnInit() {
        this.options['slidesPerView'] = 4;

        // if(this.isItemDetails)
        this.model = this.appDataService.getItemModel(this.model.data.id); // to get core item.
    }

    close(event = true) {
        // //console.log'### EVENT', event)
        if(event)
            this.events.publish(this.propsEvent+'_closed');
        this.modalController.dismiss();
    }
}
